import { useMemo } from 'react'
import { useTheme } from '@mui/material/styles'

const useStyle = <T>(generator: (theme, props: object) => T, props: object = {}): T => {
    const theme = useTheme()

    return useMemo(() => {
        return generator(theme, props)
    }, [
        theme,
        generator,
        props,
    ])
}

export default useStyle
